import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  padding: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  border: 2px solid #efefef;
  border-radius: 8px;
  background: white;
`;
